/**
 * Whether the public directory is open to the world.
 *
 * The catalogue is in beta and currently closed: it is reachable by URL, but it
 * lists nobody, offers no search, and no therapist can publish into it. One
 * constant rather than four scattered checks, so opening it again is a
 * single-line change and cannot be half-done — a live "Publish" button beside a
 * closed catalogue is what puts a profile somewhere nobody can read it.
 */
export const DIRECTORY_ENABLED = false;
